import { render, staticRenderFns } from "./IristarDividing.vue?vue&type=template&id=273848ef&"
import script from "./IristarDividing.vue?vue&type=script&lang=js&"
export * from "./IristarDividing.vue?vue&type=script&lang=js&"
import style0 from "./IristarDividing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports